import { render, staticRenderFns } from "./RoomBookingActions.vue?vue&type=template&id=487acc84&scoped=true"
import script from "./RoomBookingActions.vue?vue&type=script&lang=js"
export * from "./RoomBookingActions.vue?vue&type=script&lang=js"
import style0 from "./RoomBookingActions.vue?vue&type=style&index=0&id=487acc84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487acc84",
  null
  
)

export default component.exports